export enum additionalContentCodes {
  BASE_HEADER = "BASE_HEADER",
  HEADER_WITH_STATUS_IMG = "HEADER_WITH_STATUS_IMG",
  WARNING_HEADER = "WARNING_HEADER",
}
